import { createFileRoute, redirect } from "@tanstack/react-router";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { StoresOpeningPage } from "@/features/stores/components/opening-page";

export const Route = createFileRoute("/_app/stores/opening")({
  beforeLoad: () => {
    if (!useAuth.getState().can("stores.opening"))
      throw redirect({ to: "/stores/arrivals" });
  },
  component: Page,
});

function Page() {
  const { selected, ready } = useFacilities();
  if (!ready) return <FormPageSkeleton />;
  return <StoresOpeningPage facilityId={selected?.id} />;
}
